import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RequestDepartment } from '../../../../models/request-department.model';

@Component({
    selector: 'app-department-card',
    templateUrl: './department-card.component.html',
    styleUrls: ['./department-card.component.scss'],
})
export class DepartmentCardComponent {
    @Input() department: RequestDepartment;

    @Output() edit = new EventEmitter<RequestDepartment>();

    @Output() delete = new EventEmitter<RequestDepartment>();

    constructor(private translate: TranslateService) {}

    onEdit(): void {
        this.edit.emit(this.department);
    }

    onDelete(): void {
        this.delete.emit(this.department);
    }
}
